var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:['hermit_crab', ( _obj = {}, _obj[_vm.tableClass] = _vm.from, _obj )],attrs:{"src":_vm.$image(("normal/buttons/decoration/hermit_crab-" + _vm.type + ".svg")),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }